import { Component, OnInit, Input, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FunctionsService } from 'src/app/services/functions.service';
import { ApiService } from 'src/app/api.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { aggressor } from 'src/app/models/aggressorModel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-view-user',
    templateUrl: './view-user.component.html',
    styleUrls: ['./view-user.component.css']
})
export class ViewUserComponent implements OnInit, AfterViewInit {
  
    @ViewChild('deleteAggressorModal') deleteAggressorModal!: TemplateRef<any>;
    @Input() set userToView(value: any) {
        value["dob"] = value["dob"]?this.functionsService.convertUTCDateToLocalDateOnly(value["dob"]+'T12:00:00'):'';
        this._userToView = value;
    }

    _userToView: any = {
        userPhoto: ""
    };
    c_fields: any;
    fieldOption: boolean = false;
    geoAssignment: boolean = false;
    dob: string;
    aggressors: aggressor[];
    aggressorToDelete: any = null;
    deleteReason: string = '';
    deleteReasonError: boolean = false;
    userId: string;
    participantId: string;

      filteredAggressors: any[] = [];

  // Filter properties
  filters = {
    name: '',
    status: 'All',
    startDate: '',
    endDate: ''
  };

    constructor(
        private functionsService: FunctionsService,
        private route: ActivatedRoute,
        private apiService: ApiService,
        public translate:TranslateService,
        public spinner: NgxSpinnerService,
        public router: Router,
        private modalService: NgbModal

    ) {
        this.geoAssignment = JSON.parse(localStorage.getItem('geoAssignment'));
        this.getUserFieldOption();
        
     }
    ngOnInit() {
        this.translate.onLangChange.subscribe(() => {
            if(this._userToView && this._userToView["dob"])
                this.dob = this.functionsService.convertUTCDateToLocalDateOnly((this._userToView["dob"]+'T12:00:00'));
        })
        this.getUser();
        this.loadAggressors();
        // this.loadAggressorsFiltered();
        this.userId = this.route.snapshot.paramMap.get('id')
        this.participantId = this.route.snapshot.paramMap.get('id')

    }

    ngAfterViewInit():void {
      this.clearFilters();
    }

    getUser() {
        this.spinner.show()
        this.apiService.getProfile(this.route.snapshot.paramMap.get('id'))
            .subscribe(
                data => {
                    this._userToView = data;
                    this.dob = this._userToView["dob"] ? this.functionsService.convertUTCDateToLocalDateOnly((this._userToView["dob"]+'T12:00:00')) : "";
                    this.apiService.getFieldsName(this.route.snapshot.paramMap.get('id')).subscribe(
                        data =>{
                            this.c_fields = data;
                            this.spinner.hide();
                        },
                        error => {
                            this.functionsService.errorHandler(error["status"]);
                            this.spinner.hide();
                        }
                    )
                },
                error => {
                    this.functionsService.errorHandler(error["status"]);
                    this.spinner.hide();
                }
            );
    }
    getUserFieldOption() {
        this.spinner.show();
        this.apiService.getUserFieldOption().subscribe(
            data => {
              if(data["userFieldOption"] == "YES"){
                this.fieldOption = true;
              }
              this.spinner.hide();
            },
            error => {
                this.fieldOption = false;
                this.spinner.hide();
            }
        );
    }


  /**
   * Clear all filters
   */
  clearFilters(): void {
    this.filters = {
      name: '',
      status: '',
      startDate: '',
      endDate: ''
    };
    this.applyFilters();
  }

    /**
   * Handle image loading with error prevention
   */
  getAggressorImageUrl(aggressor: any): string {
    if (!aggressor || aggressor._imageLoadError) {
      return 'assets/images/default-aggressor.png';
    }
    
    if (!aggressor.imageUrl || aggressor.imageUrl.trim() === '') {
      return 'assets/images/default-aggressor.png';
    }
    
    return aggressor.imageUrl;
  }

  handleImageError(event: any, aggressor: any): void {
    event.target.onerror = null;
    
    if (aggressor) {
      aggressor._imageLoadError = true;
    }
    
    event.target.src = 'assets/images/default-aggressor.png';
  }

  /**
   * Get status text for display
   */
  getStatusText(status: number): string {
    switch (status) {
      case 1: return this.translate.instant('aggressor.status_active');
      case 2: return this.translate.instant('aggressor.status_expiring');
      case 3: return this.translate.instant('aggressor.status_inactive');
      case 4: return this.translate.instant('aggressor.status_cancelled');
      case 5: return this.translate.instant('aggressor.status_pending');
      default: return this.translate.instant('aggressor.status_unknown');
    }
  }

    loadAggressors():void {
        this.apiService.getAggressorsByParticipant(this.route.snapshot.paramMap.get('id'))
            .subscribe(
                (data) => {
                    this.aggressors = data;
                    this.filteredAggressors = [...data];


                },
                (error) => {
                    console.error('Error loading aggressors:', error);
                }
            );
    }


    onEditAggressor(aggressor: any): void {
    console.log('Editing aggressor:', aggressor);
    
    // Opción 1: Navegar a página de edición
     this.router.navigate(['main/view-user/:id/:aggressorId']);
    
    // Opción 2: Abrir modal de edición
    // this.openEditModal(aggressor);
    
    // Placeholder - implementa según tu necesidad
    // alert(`Editar agresor: ${aggressor.aggressorName}`);
}


onAddAggressor(): void {
    console.log('Adding new aggressor');
    
     this.router.navigate([`main/view-user/${this.userId}/add-aggressor`]);

}

onDeleteAggressor(aggressor: any): void {
  this.aggressorToDelete = aggressor;
  this.deleteReason = '';
  this.deleteReasonError = false;
  
  this.modalService.open(this.deleteAggressorModal, {
    centered: true,
    backdrop: 'static',
    size: 'md'
  });
}
  
confirmDelete(): void {
  // if (!this.deleteReason || this.deleteReason.trim() === '') {
  //   this.deleteReasonError = true;
  //   return;
  // }
  
  this.deleteReasonError = false;
  this.spinner.show();
  
  const deletePayload = {
    deleteReason: this.deleteReason.trim()
  };
  
  this.apiService.deleteAggressor(this.aggressorToDelete.id, deletePayload).subscribe({
    next: (response) => {
      this.spinner.hide();
      this.modalService.dismissAll();
      
      // Remove from lists
      this.aggressors = this.aggressors.filter(a => a.id !== this.aggressorToDelete.id);
      this.filteredAggressors = this.filteredAggressors.filter(a => a.id !== this.aggressorToDelete.id);
      
      // alert(this.translate.instant('aggressor.delete_success'));
      
      // Clear variables
      this.aggressorToDelete = null;
      this.deleteReason = '';
    },
    error: (error) => {
      this.spinner.hide();
      console.error('Error deleting aggressor:', error);
      alert(this.translate.instant('error.server_error'));
    }
  });
}


/**
 * Update filter types for date objects
 */
applyFilters(): void {
  let filtered = [...this.aggressors];

  // Filter by name
  if (this.filters.name.trim()) {
    const searchTerm = this.filters.name.toLowerCase().trim();
    filtered = filtered.filter(aggressor =>
      aggressor.aggressorName.toLowerCase().includes(searchTerm)
    );
  }

  // Filter by status
  if (this.filters.status) {
    filtered = filtered.filter(aggressor =>
      aggressor.status.toString() === this.filters.status
    );
  }

  // Filter by start date (protection order start date >= filter date)
  if (this.filters.startDate) {
    const filterStartDate = new Date(this.filters.startDate);
    filtered = filtered.filter(aggressor => {
      const aggressorStartDate = new Date(aggressor.protectionOrderStartDate);
      return aggressorStartDate >= filterStartDate;
    });
  }

  // Filter by end date (protection order end date <= filter date)
  if (this.filters.endDate) {
    const filterEndDate = new Date(this.filters.endDate);
    filtered = filtered.filter(aggressor => {
      const aggressorEndDate = new Date(aggressor.protectionOrderEndDate);
      return aggressorEndDate <= filterEndDate;
    });
  }

  this.filteredAggressors = filtered;
}

/**
 * Clear start date filter
 */
clearStartDateFilter(): void {
  this.filters.startDate = null;
  this.applyFilters();
}

/**
 * Clear end date filter  
 */
clearEndDateFilter(): void {
  this.filters.endDate = null;
  this.applyFilters();
}


}